import React from 'react';
import PropTypes from 'prop-types';
import { graphql, useStaticQuery } from 'gatsby';
import classNames from 'classnames/bind';

import Heading from 'components/shared/heading';
import Link from 'components/shared/link';
import shape1 from './images/shape-1.svg';

import styles from './recent-newsletters.module.scss';

const cx = classNames.bind(styles);

const RecentNewsletters = ({ title, background }) => {
  const {
    allWpPage: { nodes: items },
  } = useStaticQuery(graphql`
    query {
      allWpPage(
        limit: 4
        sort: { date: DESC }
        filter: { uri: { regex: "/newsletter-archive/", ne: "/newsletter-archive/" } }
      ) {
        nodes {
          uri
          acf {
            heroTitle
            heroDescription
          }
        }
      }
    }
  `);

  return (
    <section className={cx('wrapper', background)}>
      <div className={cx('container')}>
        <Heading className={cx('title')} tag="h2" size="xl">
          {title}
        </Heading>

        <div className={cx('items')}>
          {items.map(({ acf: { heroTitle: title, heroDescription: description }, uri }, index) => (
            <Link className={cx('item')} to={uri} key={index}>
              <div className={cx('item-head')}>
                <Heading className={cx('item-title')} tag="h3" size="md">
                  {title}
                </Heading>
                {description && <p className={cx('item-description')}>{description}</p>}
              </div>
              <div className={cx('item-footer')}>
                <span className={cx('item-read-more')}>Read more</span>
              </div>
            </Link>
          ))}

          <img className={cx('shape-1')} src={shape1} alt="" loading="lazy" aria-hidden />
        </div>
      </div>
    </section>
  );
};

RecentNewsletters.propTypes = {
  title: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
};

export default RecentNewsletters;
